import { render } from "./TargetingValue.vue?vue&type=template&id=18951582&scoped=true"
import script from "./TargetingValue.vue?vue&type=script&lang=js"
export * from "./TargetingValue.vue?vue&type=script&lang=js"

import "./TargetingValue.vue?vue&type=style&index=0&id=18951582&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18951582"]])

export default __exports__